import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import ActionButton from '../action-button/action-button.component';
import IconBlockSuccess from '../icon-block-success/icon-block-success.component';
import DeleteIcon from '../../icons/delete-icon';
import useStylesTooltipDialog from './tooltip-dialog.styles';

const TooltipDialog: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    title,
    onConfirm,
    onCancel,
  } = props;

  const { classes } = useStylesTooltipDialog();

  return (
    <FlexContainer isColumn className={classes.tooltipDialog}>
      <FlexContainer>
        {title}
      </FlexContainer>
      <FlexContainer className={classes.tooltipDialogButtonsBlock}>
        <ActionButton
          isLight
          withSmallPadding
          onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
            if (onConfirm) {
              onConfirm(event);
            }
          }}
        >
          <IconBlockSuccess isDisabled />
        </ActionButton>
        <ActionButton
          isLight
          withSmallPadding
          onClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
            if (onCancel) {
              onCancel(event);
            }
          }}
        >
          <DeleteIcon />
        </ActionButton>
      </FlexContainer>
    </FlexContainer>
  );
});

export default TooltipDialog;
